function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "\uF0DC");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Table/Filter-Icon-Copy-14",
  transform: "translate(0.000000, -6.000000)",
  fill: "#6B79A4",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8,7.40000119 C8.00000954,7.53281445 7.94532197,7.6578146 7.85157186,7.75156471 L4.35156769,11.2515689 C4.25781758,11.345319 4.13281743,11.4000066 4,11.4000012 C3.86719211,11.4000066 3.74219196,11.345319 3.64844185,11.2515689 L0.148437677,7.75156471 C0.0546875652,7.6578146 0,7.53281445 0,7.40000119 C0,7.12656396 0.22656277,6.90000119 0.5,6.90000119 L7.5,6.90000119 C7.77344677,6.90000119 8.00000954,7.12656396 8,7.40000119 Z",
  id: "\\uF0DC"
})));

const SvgDown = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "6px",
    viewBox: "0 0 8 6",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/down.378de141.svg";
export { ForwardRef as ReactComponent };